var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.params.value)?_c('c-volume',{class:_vm.paddingClass,attrs:{"volume":{
    value: this.params.value,
    pct: (100 / this.params.context[("max" + (this._.capitalize(this.params.valueType)) + "Size")]) * this.params.value,
    direction: this.params.direction,
    barColor: _vm.barColor
  }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }